/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICustomLinkData } from './custom-link.data';
import { ICustomLinkProps } from './custom-link.props.autogenerated';

export interface ICustomLinkViewProps extends ICustomLinkProps<ICustomLinkData> {}

/**
 *
 * CustomLink component
 * @extends {React.PureComponent<ICustomLinkProps<ICustomLinkData>>}
 */
class CustomLink extends React.PureComponent<ICustomLinkProps<ICustomLinkData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default CustomLink;
